<ng-template #modalTemplate let-modal>
  <div class="modal-header">
    <h4 class="modal-title">
      {{ (title || 'Confirm Action') | translate }}
    </h4>
    <button type="button" class="btn-close no-drag  " aria-label="Close" (click)="dismiss()">
    </button>
  </div>

  <div class="modal-body">
    <p>{{ (message || 'Are you sure?') | translate }}</p>
    <p *ngIf="submessage" class="text-muted">
      {{ submessage | translate }}
    </p>

    <div *ngIf="warningMessage" class="alert alert-warning d-flex align-items-start gap-2 mt-2 mb-0">
      <i class="ti ti-alert-triangle fs-5 flex-shrink-0 mt-1"></i>
      <span>{{ warningMessage | translate }}</span>
    </div>

    <div *ngIf="freeAcceptance !== undefined || cost !== undefined" class="alert alert-info d-flex align-items-center gap-2 mt-2 mb-0">
      <i class="ti ti-coin-euro fs-5 flex-shrink-0"></i>
      <span *ngIf="freeAcceptance === true"><strong>{{ 'Included' | translate }}</strong></span>
      <span *ngIf="freeAcceptance !== true">
        {{ 'Cost' | translate }}<strong *ngIf="cost !== undefined"> &ndash; €{{ cost | number:'1.2-2' }}</strong>
      </span>
    </div>

    <!-- Services lists -->
    <div *ngIf="includedServices.length > 0 || excludedServices.length > 0" class="services-section mt-3 mb-3">
      <div *ngIf="includedServices.length > 0" class="mb-3">
        <h6 class="fw-semibold text-success mb-2">
          <span class="material-symbols-outlined" style="font-size: 1.2rem; vertical-align: middle;">check_circle</span>
          {{ 'Included Services' | translate }}
        </h6>
        <ul class="list-unstyled ms-3">
          <li *ngFor="let service of includedServices" class="d-flex align-items-center gap-2 mb-1">
            <span class="material-symbols-outlined text-success" style="font-size: 1rem;">done</span>
            <span>{{ service }}</span>
          </li>
        </ul>
      </div>

      <div *ngIf="excludedServices.length > 0">
        <h6 class="fw-semibold text-danger mb-2">
          <span class="material-symbols-outlined" style="font-size: 1.2rem; vertical-align: middle;">cancel</span>
          {{ 'Excluded Services' | translate }}
        </h6>
        <ul class="list-unstyled ms-3">
          <li *ngFor="let service of excludedServices" class="d-flex align-items-center gap-2 mb-1">
            <span class="material-symbols-outlined text-danger" style="font-size: 1rem;">close</span>
            <span>{{ service }}</span>
          </li>
        </ul>
      </div>
    </div>

    <div *ngIf="showPhoneShareCheckbox" class="phone-share-section mt-3">
      <div *ngIf="phoneShareMessage" class="alert alert-info d-flex align-items-start gap-2 mb-3">
        <span class="material-symbols-outlined">info</span>
        <small>{{ phoneShareMessage | translate }}</small>
      </div>

      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="phoneShareCheckbox" [(ngModel)]="phoneShareAccepted">
        <label class="form-check-label" for="phoneShareCheckbox">
          {{ checkboxText | translate }}
        </label>
      </div>
    </div>

    <div *ngIf="requirePhoneDigits" class="phone-digits-section mt-3">
      <div class="mb-3">
        <label class="form-label" for="phoneDigitsInput">
          {{ 'Last 3 digits of phone number' | translate }} *
        </label>
        <input
          type="text"
          class="form-control"
          id="phoneDigitsInput"
          [(ngModel)]="phoneDigits"
          maxlength="3"
          pattern="\d{3}"
          placeholder="XXX"
          required
          [class.is-invalid]="isPhoneDigitsInvalid()"
        >
        <div class="invalid-feedback" *ngIf="isPhoneDigitsInvalid()">
          {{ 'Please enter exactly 3 digits' | translate }}
        </div>
        <small class="form-text text-muted">
          {{ 'Enter the last 3 digits of the phone number you will call the patient with' | translate }}
        </small>
      </div>
    </div>
  </div>

  <div *ngIf="reportMode" class="m-3 mt-0">
    <div class="mb-3">
      <label class="form-label">Reason *</label>
      <select class="form-select" [(ngModel)]="selectedMotivation" required>
        <option [ngValue]="null" disabled>Select reason...</option>
        <option *ngFor="let m of motivationsWithLabels" [ngValue]="m.value">{{ m.label }}</option>
      </select>
    </div>

    <div class="mb-3">
      <label class="form-label">Explanation *</label>
      <textarea class="form-control" [(ngModel)]="motivationText" rows="3" required></textarea>
    </div>
  </div>

  <div class="modal-footer d-flex align-items-center justify-content-end">

    <app-button label="{{ (cancelText || 'Cancel') | translate }}" buttonType="light" type="button"
                (onClick)="dismiss()">
    </app-button>

    <app-button label="{{ (confirmText || 'Confirm') | translate }}" buttonType="success" [icon]="icon"
                [cssClass]="confirmButtonClass" [outlined]="false" iconPosition="left" type="button"
                (onClick)="confirm()"
                [isDisabled]="!isFormValid">
    </app-button>

  </div>

</ng-template>
